import React, { useState } from 'react'
import { Panel, Row, Col, Input, SelectPicker } from 'rsuite'
import SearchButton from './../../components/buttons/searchButton/SearchButton'
import CancelButton from './../../components/buttons/cancelButton/CancelButton'
import DatePickerCustom from './../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import { REQUEST_DATE_FORMAT } from './../../constants/date'

export default function SearchFormExpertPayment({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [idCard, setIdCard] = useState()
  const [projectId, setProjectId] = useState()
  const [firstName, setFirstName] = useState()
  const [lastName, setLastName] = useState()

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.idCard.label}
            <Input
              placeholder={schema.idCard.hint || schema.idCard.label}
              value={idCard}
              onChange={(value) => {
                setIdCard(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.projectId.label}
            <Input
              placeholder={schema.projectId.hint || schema.projectId.label}
              value={projectId}
              onChange={(value) => {
                setProjectId(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.firstName.label}
            <Input
              placeholder={schema.firstName.hint || schema.firstName.label}
              value={firstName}
              onChange={(value) => {
                setFirstName(value)
              }}
            />
          </Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.lastName.label}
            <Input
              placeholder={schema.lastName.hint || schema.lastName.label}
              value={lastName}
              onChange={(value) => {
                setLastName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                let request = {
                  idCard: idCard,
                  projectId: projectId,
                  firstName: firstName,
                  lastName: lastName,
                }
                onSearch(request)
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                setIdCard('')
                setProjectId('')
                setFirstName('')
                setLastName('')
                onSearch({})
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
